import React from 'react';
import { fetchCareSourceById } from '../../../features/careSourceProcessing/careSourceActivityService';

const getAudioAttachments = (source = {}) => {
  const attachments = [
    ...(Array.isArray(source.audioAttachments) ? source.audioAttachments : []),
    ...(Array.isArray(source.sourceMetadata?.audioAttachments) ? source.sourceMetadata.audioAttachments : []),
    ...(Array.isArray(source.metadata?.source?.audioAttachments) ? source.metadata.source.audioAttachments : []),
  ];
  return attachments.filter((attachment, index) => (
    attachment?.url && attachments.findIndex((candidate) => candidate?.url === attachment.url) === index
  ));
};

const useLinkedSourceAudio = ({ sourceNoteId = '', enabled = false } = {}) => {
  const [attachments, setAttachments] = React.useState([]);

  React.useEffect(() => {
    let active = true;
    if (!enabled || !sourceNoteId) {
      setAttachments([]);
      return () => { active = false; };
    }

    fetchCareSourceById(sourceNoteId)
      .then((source) => {
        if (active) setAttachments(getAudioAttachments(source || {}));
      })
      .catch(() => {
        if (active) setAttachments([]);
      });

    return () => { active = false; };
  }, [enabled, sourceNoteId]);

  return attachments;
};

export default useLinkedSourceAudio;
